import React from 'react';
import { Layer, Source } from 'react-map-gl';
import { createSelector } from 'reselect';
import { IScoutingEntry, ScoutingEntryHelper } from '../../../../../types/model/scouting/scoutingEntry';

interface IScoutingAssignmentObservationMarkersProps {
    polygonId : string;

    polygonBeforeId ?: string;

    minZoom ?: number;
    maxZoom ?: number;

    visible ?: boolean;

    assignmentId : string;
}

interface IScoutingAssignmentObservationMarkersState {
    entries : Array<IScoutingEntry>;
}

export default class ScoutingAssignmentObservationMarkers extends React.PureComponent<IScoutingAssignmentObservationMarkersProps, IScoutingAssignmentObservationMarkersState> {
    private listener ?: () => void;

    constructor(props : IScoutingAssignmentObservationMarkersProps) {
        super(props);
        this.state = {
            entries: [],
        };
    }

    public componentDidMount() : void {
        this.load();
    }

    private readonly load = () => {
        this.listener = ScoutingEntryHelper.observationOollection(this.props.assignmentId).onSnapshot((snapshot) => {
            const entries = this.state.entries.slice();

            // "added" | "removed" | "modified"
            snapshot.docChanges().forEach((f) => {
                const entry = f.doc.data();

                const index = f.newIndex;

                switch (f.type) {
                    case 'added':
                        entries.splice(index, 1, entry);
                        break;
                    case 'modified':
                        entries.splice(f.oldIndex, 1);
                        entries.splice(index, 1, entry);
                        break;
                    case 'removed':
                        entries.splice(f.oldIndex, 1);
                        break;
                }
            });

            this.setState({
                entries,
            });
        });
    };

    public componentWillUnmount() : void {
        if (this.listener) {
            this.listener();
        }
    }

    private readonly getEntries = (props : IScoutingAssignmentObservationMarkersProps, state : IScoutingAssignmentObservationMarkersState) => state.entries;

    private readonly getFeatureCollection = createSelector(
        [
            this.getEntries,
        ],
        (
            entries,
        ) => {
            const geoJson : GeoJSON.FeatureCollection<GeoJSON.Point, {
                id : string;
                color : string;
            }> = {
                type: 'FeatureCollection',
                features: entries.map((n, key) => ({
                    geometry: {
                        coordinates: [n.point.longitude, n.point.latitude],
                        type: 'Point',
                    },
                    type: 'Feature',
                    properties: {
                        id: `${key}`,
                        color: 'blue',
                    },
                })),
            };

            return geoJson;
        },
    );
    
    public readonly render = () => {
        const {
            minZoom = 0,
            maxZoom = 24,
            polygonId,
            polygonBeforeId,
            visible = true,
        } = this.props;

        const data = this.getFeatureCollection(this.props, this.state);

        return (

            <Source
                id={`${polygonId}_source`}
                type='geojson'
                data={data}
                maxzoom={maxZoom}
            >
                <Layer
                    {...{
                        id: polygonId,
                        type: 'circle',
                        minzoom: minZoom,
                        maxzoom: maxZoom,
                        'layout': {
                            visibility: visible ? 'visible' : 'none',
                        },
                        'paint': {
                            'circle-color': ['get', 'color'],
                            'circle-opacity': 1,
                        },
                        beforeId: polygonBeforeId,
                    }}
                />
                <Layer
                    {...{
                        id: `${polygonId}_circle`,
                        type: 'circle',
                        minzoom: minZoom,
                        maxzoom: maxZoom,
                        'layout': {
                            visibility: visible ? 'visible' : 'none',
                        },
                        'paint': {
                            'circle-color': ['get', 'color'],
                            'circle-stroke-color': ['get', 'color'],
                            'circle-opacity': 0,
                            'circle-radius': 8,
                            'circle-stroke-width': 1,
                        },
                        beforeId: polygonBeforeId,
                    }}
                />
            </Source>
        );
    };
}
